import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ENUMS from '../../../enums/index';
import * as messagesActions from '../../../redux/messages/actions';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Spin from '../../../components/loading';
import { numberWithCommas } from '../../../utils/formatter';
import { enumHelper } from '../../../utils';

class MessageDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertFlag: false
    };
  }

  componentDidMount() {
    this.props.fetchMessageDetails(this.props.messageId);
  }

  render() {
    let { messageId, loading, error, failed, message, messageDetails } = this.props;

    let {
      title,
      body,
      createdAt,
      creator,
      expiredAtJalaali,
      isPublished,
      isViewable,
      minOrderInReservationValue,
      minSuccessfulReservationValue,
      orderInReservationUserIds,
      publishedAt,
      publisher,
      receiverType,
      specialUsers,
      successfulReservationUserIds,
      persons,
      status,
      startAt,
      endAt,
      respondedAt,
      trackingNumber,
      baseCost,
      meal,
      reserveType,
      respondedFullName,
      reservedTables
    } = messageDetails;

    return (
      <>
        <Modal id="financial-transaction-modal" size="xl" isOpen={this.props.isOpen}>
          <ModalHeader>
            <div className="row">
              <div className="col-11">{locales('titles.messageDetails')}</div>
              <div className="col-1 text-left">
                <a
                  href="#"
                  className=""
                  onClick={event => {
                    event.preventDefault();
                    this.props.closeModal();
                  }}
                >
                  <i className="fas fa-times"></i>
                </a>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <Spin spinning={loading}>
              <article>
                {error ? (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                ) : (
                  <>
                    {this.state.alertFlag && (
                      <div className="alert alert-success">
                        {locales('titles.reserveStartedAndRedirected')}
                      </div>
                    )}
                    <article className="col-12">
                      <div className="col-12 p-0 py-1 font-weight-bold text-dark">
                        {locales('titles.messageBasicInfo')}
                      </div>

                      <div className="col-12 d-flex border rounded py-2 px-1 flex-wrap">
                        <div className="col-12 d-flex  px-1 my-2">
                          <div className="col-6 d-flex align-items-center">
                            <div className="col-5 text-muted">{locales('tables.creator')} : </div>
                            <div className="col-7 text-dark font-weight-bold font-large">{creator}</div>
                          </div>
                          <div className="col-6 d-flex justify-content-end align-items-center p-0">
                            <div className="col-5 text-muted text-left">{locales('fields.createdAt')} : </div>
                            <div className="col-7 text-left text-dark font-weight-bold font-large">
                              {createdAt}
                            </div>
                          </div>
                        </div>
                        <div className="col-12 d-flex  px-1 my-2">
                          <div className="col-6 d-flex align-items-center">
                            <div className="col-5 text-muted">{locales('tables.publisher')} : </div>
                            <div className="col-7 text-dark font-weight-bold font-large">{publisher}</div>
                          </div>
                          <div className="col-6 d-flex justify-content-end align-items-center p-0">
                            <div className="col-5 text-muted text-left">
                              {locales('tables.expiredAtJalaali')} :{' '}
                            </div>
                            <div className="col-7 text-left text-dark font-weight-bold font-large">
                              {expiredAtJalaali}
                            </div>
                          </div>
                        </div>
                        <div className="col-12 d-flex  px-1 my-2">
                          <div className="col-6 d-flex align-items-center">
                            <div className="col-5 text-muted">{locales('tables.isPublished')} : </div>
                            <div className="col-7 text-dark font-weight-bold font-large">
                              <input type="checkbox" checked={isPublished} disabled={true} />
                            </div>
                          </div>
                          <div className="col-6 d-flex justify-content-end align-items-center p-0">
                            <div className="col-5 text-muted text-left">
                              {locales('tables.isViewable')} :{' '}
                            </div>
                            <div className="col-7 text-left text-dark font-weight-bold font-large">
                              <input type="checkbox" checked={isViewable} disabled={true} />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mt-4">
                        <div className="col-12 p-0 py-1 font-weight-bold text-dark">
                          {locales('titles.messageInfo')}
                        </div>
                        <div className="col-12 d-flex py-2 px-1 flex-wrap border rounded">
                          <div className="col-12 d-flex text-dark font-weight-bold font-large px-1 my-2">
                            {title}
                          </div>
                          <div className="col-12 d-flex  px-1 my-2">{body}</div>
                        </div>
                      </div>

                      <div className="mt-4">
                        <div className="col-12 p-0 py-1 font-weight-bold text-dark">
                          {locales('titles.messageReceiverInfo')}
                        </div>
                        <div className="col-12 d-flex border rounded py-2 px-1 flex-wrap">
                          <div className="col-12 d-flex  px-1 my-2">
                            <div className="col-6 d-flex align-items-center">
                              <div className="col-5 text-muted">{locales('labels.receiverType')} : </div>
                              <div className="col-7 text-dark font-weight-bold font-large">
                                {receiverType &&
                                  receiverType.length &&
                                  enumHelper.convertEnumValueToTitle(
                                    ENUMS.MESSAGE_RECEIVERS.list,
                                    receiverType
                                  )}
                              </div>
                            </div>
                          </div>

                          {minOrderInReservationValue && (
                            <div className="col-12 d-flex  px-1 my-2">
                              <div className="col-6 d-flex align-items-center">
                                <div className="col-5 text-muted">
                                  {locales('tables.minOrderInReservation')} :{' '}
                                </div>
                                <div className="col-7 text-dark font-weight-bold font-large">
                                  {numberWithCommas(minOrderInReservationValue)}
                                </div>
                              </div>
                            </div>
                          )}

                          {minSuccessfulReservationValue && (
                            <div className="col-12 d-flex  px-1 my-2">
                              <div className="col-6 d-flex align-items-center">
                                <div className="col-5 text-muted">
                                  {locales('tables.minSuccessfulReservationValue')} :{' '}
                                </div>
                                <div className="col-7 text-dark font-weight-bold font-large">
                                  {numberWithCommas(minSuccessfulReservationValue)}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="mt-4">
                        {specialUsers && specialUsers.length && (
                          <table className="table table-hover table-light table-striped table-ellipsis">
                            <thead>
                              <tr>
                                <th className="text-center">{locales('tables.row')}</th>
                                <th className="text-center">{locales('tables.fullName')}</th>
                                <th className="text-center">{locales('tables.userName')}</th>
                                <th className="text-center">{locales('tables.mobileNumber')}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {specialUsers.map((user, index) => (
                                <tr key={user.id}>
                                  <td className="text-center">{index + 1}</td>
                                  <td className="text-center">{user.fullName}</td>
                                  <td className="text-center">{user.userName}</td>
                                  <td className="text-center">{user.mobileNumber}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </div>
                    </article>
                  </>
                )}
              </article>
            </Spin>
          </ModalBody>
          <ModalFooter>
            <div className="d-flex col-12 justify-content-end align-items-center">
              <button className="btn btn-default mx-1" onClick={() => this.props.closeModal()}>
                {locales('labels.cancel')}
              </button>
            </div>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    messageDetails: state.messagesReducer.messageObject,
    loading: state.messagesReducer.fetchMessageByIdLoading,
    message: state.messagesReducer.fetchMessageByIdMessage,
    failed: state.messagesReducer.fetchMessageByIdFailed,
    error: state.messagesReducer.fetchMessageByIdError
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchMessageDetails: id => dispatch(messagesActions.fetchMessageById(id))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MessageDetails);
